import { render, staticRenderFns } from "./ScreenPersonalizado.vue?vue&type=template&id=2ff4c158&scoped=true&"
import script from "./ScreenPersonalizado.vue?vue&type=script&lang=js&"
export * from "./ScreenPersonalizado.vue?vue&type=script&lang=js&"
import style0 from "./ScreenPersonalizado.vue?vue&type=style&index=0&id=2ff4c158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4c158",
  null
  
)

export default component.exports